<div class="form-group col-md-12 col-xs-12 margin-bottom-5px  margin-left-15px" >

  <div class="row" *ngIf="field" hidden >
    <div class="col-md-3 text-align-right">
      <label for="firstName" class="margin-bottom-0px margin-top-5px "> {{field.Title}}</label>
    </div>
    <div class="col-md-1 padding-left-0px padding-right-0px text-align-center">
      <!--<label>{{field.Value}}</label>-->

      <input type="checkbox" class="width-15px background-2" [(ngModel)]="field.Value" name="field.Value">






    </div>
    <div class="col-md-4">
      <!--<label>{{field.Value}}</label>-->
      <!--<input type="text" class="form-control" [(ngModel)]="field.Remarks" [ngModelOptions]="{standalone: true}"/>-->
      <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Remarks"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="field.Remarks" maxlength="100"></textarea>





    </div>
  </div>
  <div class="row" *ngIf="Data && Data.HasChildren">
    <div class="col-md-12 padding-l-0px" *ngFor="let f of  Data.Children">
      <div [ngSwitch]="f.Data.ValueType">
        <div class="row margin-top-3px " *ngSwitchCase="'Bool'">
          <auto-gen-bool class="col-md-12 " [Data]="f" [field]="f.Data" [mode]="mode">
          </auto-gen-bool>
        </div>
        <div class="row " *ngSwitchCase="'List'">
          <auto-gen-list class="col-md-12" [Data]="f" [field]="f.Data" [mode]="mode">
          </auto-gen-list>
        </div>
        <div class="row margin-top-5px" *ngSwitchCase="'Text'">
          <auto-gen-text class="col-md-12" [field]="f.Data" [mode]="mode"></auto-gen-text>
        </div>
        <div class="row" *ngSwitchCase="'CVS'">
          <auto-gen-cvs class="col-md-12" [field]="f.Data" FormMode="View" [mode]="mode"></auto-gen-cvs>
        </div>
        <div class="row" *ngSwitchCase="'CsvList'">
          <auto-gen-csvlist class="col-md-12" [field]="f.Data" [Data]="f" FormMode="View" [mode]="mode"></auto-gen-csvlist>
        </div>
        <div class="row" *ngSwitchCase="'Date'">
          <auto-gen-date class="col-md-12" [field]="f.Data" [mode]="mode"></auto-gen-date>
        </div>

        <div class="row" *ngSwitchCase="'Grid'">
          <!--<label>AUTO GEN CHILDREN - GRID COMP:..............</label>-->
          <auto-gen-grid class="col-md-12" [field]="f"></auto-gen-grid>
        </div>
      </div>

      </div>
  </div>
</div>
